//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { Enums } from '../models/common/enums'
import { OperatorLayoutSetting } from '../models/local/operator-layout-setting'
import { OpFile } from '../models/core/op-file'
import { OpOperator } from 'app/models/core'

import { IUserSession } from './user-session'
import { Md5 } from './md5-helper'

var pako = require('pako')
import { ConvertHelper } from './convert-helper';

export class OperatorLayoutSettings {

    // Consts 

    private static get LOG_STRING(): string { return '[SIMAX.Helpers.OperatorLayoutSettings] - %s' }

    // Consts End


    // TODO: remove static after delete methods: "static setSetting" and "static getSetting"
    private static layoutSettings = null

    private previousMd5 = {}
    private saveTimer

    constructor(private userSession: IUserSession) {
        var saveInterval = setInterval(() => {
            this.saveSettingsToDB(1000).fail(() => {
                // the user has logged out or the session has expired
                clearInterval(saveInterval)
            })
        }, 60000)
    }

    public static initOperatorLayoutSettings(userSession: IUserSession) {
        let operatorLayoutSettings = new OperatorLayoutSettings(userSession)

        return operatorLayoutSettings
            .loadSettingsFromDb()
            .then((result: boolean) => {
                if (result) {
                    return operatorLayoutSettings
                }
                else {
                    // new user or problem in WS
                    OperatorLayoutSettings.layoutSettings = {}

                    return operatorLayoutSettings
                }
            })
    }

    public setSetting(setting: OperatorLayoutSetting, value: any) {
        // TODO: replace body from static method
        OperatorLayoutSettings.setSetting(setting.getName(), value)
    }

    public getSetting<T>(setting: OperatorLayoutSetting, defaultValue?: T): T {
        // TODO: replace body from static method
        return OperatorLayoutSettings.getSetting(setting.getName(), defaultValue)
    }

    public saveSettingsToDB(time: number = 5000, isLogout = false, callback?): JQueryPromise<void> {
        const deferred = $.Deferred<void>()
        const doSave = () => {
            setTimeout(() => {
                if (callback) callback()
            }, 5000)

            let idOperator = this.userSession.getIdLoggedOperator()
            if (OperatorLayoutSettings.layoutSettings) {
                var newMd5 = Md5.init(OperatorLayoutSettings.layoutSettings)
                if (this.previousMd5 !== newMd5 || isLogout) {
                    this.previousMd5 = newMd5

                    this.userSession
                        .getDataProvider().Operator
                        .getOperatorSettings(idOperator, [Enums.SimaxOperatorSetting.Layout])
                        .then((settings: [OpFile[]]) => {
                            let layoutSettingsFile: OpFile = null

                            if (_.size(settings) === 0 || _.size(settings[0]) === 0) {
                                layoutSettingsFile = new OpFile()
                                layoutSettingsFile.opState = Enums.OpChangeState.New
                            }
                            else {
                                layoutSettingsFile = settings[0][0]
                            }

                            if (layoutSettingsFile != null) {
                                const xml: string = '<?xml version="1.0"?><string>' + JSON.stringify(OperatorLayoutSettings.layoutSettings) + '</string>'
                                const bytes: Uint8Array = pako.gzip(ConvertHelper.unicodeStringToByteArray(xml))

                                layoutSettingsFile.fileBytes = ConvertHelper.byteArrayToBase64([].slice.apply(bytes))

                                this.userSession
                                    .getDataProvider().Operator
                                    .saveOperatorLayoutSettings(idOperator, [layoutSettingsFile], isLogout)
                                    .then(result => {
                                        if (result) {
                                            deferred.resolve()
                                        }
                                        else {
                                            deferred.reject()
                                        }
                                    })
                            }
                            else {
                                console.warn(OperatorLayoutSettings.LOG_STRING, "Unable to save layout file.")

                                deferred.reject()
                            }
                        })
                }
            }
            if (callback) callback()
        }

        if (time >= 0) {
            if (this.saveTimer) clearTimeout(this.saveTimer)
            this.saveTimer = setTimeout(() => {
                doSave()
            }, time)
        }
        else {
            doSave()
        }
        return deferred.promise()
    }

    private loadSettingsFromDb(): JQueryPromise<boolean> {
        const lastIdOperator: number = this.userSession.getDataProvider().Operator.getLastIdOperator()
        const idOperator: number = this.userSession.getIdLoggedOperator()
        const reload: boolean = !lastIdOperator || lastIdOperator != idOperator

        return this.userSession
            .getDataProvider()
            .Operator
            .getLoggedOperator()
            .then((operator: OpOperator) => {
                const idFile: number = operator.dataList.getValue(Enums.DataType.OPERATOR_LOCAL_SETTINGS)
                const layout: OpFile = this.userSession.getDataProvider().LocalStorage.getLoggedOperatorSetting(Enums.SimaxOperatorSetting.Layout)
                let needToGetlayput: boolean = false

                if (layout == null) {
                    needToGetlayput = true
                } else {
                    if (layout.idFile == null || layout.idFile != idFile) {
                        needToGetlayput = true
                    }
                }

                return this.userSession
                    .getDataProvider().Operator
                    .getOperatorSettings(idOperator, [Enums.SimaxOperatorSetting.Layout], reload || needToGetlayput)
                    .then((settings: any) => {
                        this.userSession
                            .getDataProvider().Operator
                            .setLastIdOperator(idOperator)

                        if (settings && settings.length > 0) {
                            const files: OpFile[] = settings[0]

                            if (files && files.length > 0) {
                                const file = files[0]
                                let unzippedFileData: Uint8Array = null
                                let bytes = file.fileBytes || ''

                                try {
                                    if (typeof (<number[]>bytes).map !== 'function') {
                                        unzippedFileData = pako.ungzip(ConvertHelper.base64ToByteArray(bytes as string))
                                    }
                                    else {
                                        unzippedFileData = pako.ungzip(bytes)
                                    }

                                    const xml: string = ConvertHelper.byteArrayToUnicodeString([].slice.apply(unzippedFileData))
                                    const json = xml.replace('<?xml version="1.0"?>', '').replace('<string>', '').replace('</string>', '')

                                    OperatorLayoutSettings.layoutSettings = JSON.parse(json)
                                } catch (e) {
                                    OperatorLayoutSettings.layoutSettings = {}
                                    console.error("Unable to parse json for Operator Layout Settings. Resetting...")
                                }

                                return true
                            }
                        }

                        return false
                    })
            })
    }

    /**
     * @deprecated Use userSession.setOperatorLayoutSetting
     */
    public static setSetting(name: string, value: any) {
        if (this.layoutSettings) {
            if (value != null) {
                this.layoutSettings[name] = value
            } else {
                delete this.layoutSettings[name]
            }
        } else {
            throw new Error('Layout settings are not loaded!')
        }
    }

    /**
     * @deprecated Use userSession.getOperatorLayoutSetting
     */
    public static getSetting<T>(name: string, defaultValue?: T): T {
        if (this.layoutSettings) {
            let result = this.layoutSettings[name]
            if (typeof result != 'undefined') {
                return result
            }
            return defaultValue
        } else {
            throw new Error('Layout settings are not loaded!')
        }
    }

    // TODO: delete below and use OperatorLayoutSetting with enum Enums.SimaxOperatorLayoutSetting
    static ActionAdditionalDetailsAccordions = "ActionAdditionalDetailsAccordions"
    static ActionDetailsAccordions = "ActionDetailsAccordions"
    static ActionDetailsPackets = "ActionDetailsPackets"
    static ActionDeviceId = "ActionDeviceId"
    static ActionFromDate = "ActionFromDate"
    static ActionLocationId = "ActionLocationId"
    static ActionMeterId = "ActionMeterId"
    static ActionModule = "ActionModule"
    static ActionOperator = "ActionOperator"
    static ActionState = "ActionState"
    static ActionToDate = "ActionToDate"
    static ActionType = "ActionType"
    static AlarmAccordionsSettings = "AlarmAccordionsSettings"
    static AlarmGroupsDetailsAccordions = "AlarmGroupsDetailsAccordions"
    static AlarmGroupsPopupTabActive = "AlarmGroupsPopupTabActive"
    static AlarmPopupTabActive = "AlarmPopupTabActive"
    static ConsumerDetailsAccordions = "ConsumerDetailsAccordions"
    static ContactDetailsAccordions = "ContactDetailsAccordions"
    static ContactPopupTabActive = "ContactPopupTabActive"
    static CurrentColumnSettings = "currentColumnSettings"
    static DeviceDetailsAccordions = "deviceDetailsAccordions"
    static DevicePopupTabActive = "DevicePopupTabActive"
    static DistributorDetailsAccordions = "DistributorDetailsAccordions"
    static DistributorPopupTabActive = "DistributorPopupTabActive"
    static FromDate = "FromDate"
    static IsLegendVisible = "IsLegendVisible"
    static IsRotated = "IsRotated"
    static IssueDetailsAccordions = "IssueDetailsAccordions"
    static IssuePopupTabActive = "IssuePopupTabActive"
    static LocationAccordionsSettings = "LocationAccordionsSettings"
    static LocationPopupTabActive = "LocationPopupTabActive"
    static LoggedOperator = "LoggedOperator"
    static MeasurementsGridType = "MeasurementsGridType"
    static MeterDetailsAccordions = "MeterDetailsAccordions"
    static MeterPopupTabActive = "MeterPopupTabActive"
    static OrderPopupTabActive = "OrderPopupTabActive"
    static OrderDetailsAccordions = "OrderDetailsAccordions"
    static PackagePopupTabActive = "PackagePopupTabActive"
    static PackageDetailsAccordions = "PackageDetailsAccordions"
    static ReportAccordionBellowActive = "reportAccordionBellowActive"
    static ReportDetailsAccordions = "reportDetailsAccordions"
    static ReportPopupTabActive = "reportPopupTabActive"
    static RouteDetailsAccordions = "RouteDetailsAccordions"
    static RoutePopupTabActive = "RoutePopupTabActive"
    static SecurityModuleId = "SecurityModuleId"
    static ServicemansSelection = "ServicemansSelection"
    static SharedTooltips = "SharedTooltips"
    static SimcardDetailsAccordions = "simcardDetailsAccordions"
    static SimcardPopupTabActive = "SimcardPopupTabActive"
    static SmallMenuVisibility = "smallMenu"
    static StateBeforeAuthRejection = "StateBeforeAuthRejection"
    static TaskAccordionsSettings = "TaskAccordionsSettings"
    static TaskPopupTabActive = "TaskPopupTabActive"
    static ToDate = "ToDate"
    static UserAccordionsSettings = "UserAccordionsSettings"
    static UserDepositoryAccordionsSettings = "UserDepositoryAccordionsSettings"
    static UserPopupNotificationsTabActive = "UserPopupNotificationsTabActive"
    static UserPopupSecurityTabActive = "UserPopupSecurityTabActive"
    static UserPopupTabActive = "UserPopupTabActive"
    static UserRolesList = "UserRolesList"
    static taskDetailsAccordions = "taskDetailsAccordions"
    static SupplierDetailsAccordions = "SupplierDetailsAccordions"
}